import { apiSlice } from "./apiSlice";

export const paymentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create Razorpay Order
    createRazorpayOrder: builder.mutation({
      query: (payload) => ({
        url: `/payment/create-order`,
        method: "POST",
        body: payload,
      }),
      transformResponse: (response) => {
        return response;
      },
    }),

    // Verify Razorpay Payment
    verifyRazorpayPayment: builder.mutation({
      query: (payload) => ({
        url: `/payment/verify`,
        method: "POST",
        body: payload,
      }),
      transformResponse: (response) => {
        return response;
      },
    }),

    // Get Payment Status
    getPaymentStatus: builder.query({
      query: (applicationId) => ({
        url: `/payment/status/${applicationId}`,
        method: "GET",
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["PaymentStatus"],
    }),

    // Initiate BillDesk Payment (log transaction before payment)
    initiateBillDeskPayment: builder.mutation({
      query: (payload) => ({
        url: `/gateway/initiate`,
        method: "POST",
        body: payload,
      }),
      transformResponse: (response) => {
        return response;
      },
    }),

    // Check for pending transactions
    checkPendingTransaction: builder.query({
      query: (applicationId) => ({
        url: `/gateway/pending/${applicationId}`,
        method: "GET",
      }),
      transformResponse: (response) => {
        return response;
      },
    }),
  }),
});

export const {
  useCreateRazorpayOrderMutation,
  useVerifyRazorpayPaymentMutation,
  useGetPaymentStatusQuery,
  useInitiateBillDeskPaymentMutation,
  useCheckPendingTransactionQuery,
} = paymentApi;
